<template>
  <b-row class="overflow-y py-2">
    <b-col md="6" lg="4" cols="6" v-for="i in items" :key="i">
      <div class="btn-group btn-group-toggle btn-block mb-4">
        <!-- The input prop being fed into this component contains the object for that specific slot, in this case, map (in Items, it's input['Slot Name]) -->
        <!-- IMPORTANT: the input prop in App.vue for this (input.map) is a single-level Object, input {map: {value: 'Mannfield'}}  -->
        <!-- i.e. the actual `value` of map is available inside the first level of the input.map object -->
        <!-- The input prop for any other item (e.g. bodies) in App.vue is a double-level nested Object, e.g. input {"Body": {item: {value: 'Octane'}} [map1, map2...]}  -->
        <!-- Therefore in Items.vue, to get the `value`, you go deeper - active: input.item.value, but over here, active: should refer to just input.value because that's where you can access `value` inside the object  -->
        <label
          class="btn btn-sm btn-outline-primary"
          :class="{active: input.value == i}"
        >
          <input
            type="radio"
            v-model="input.value"
            :value="i"
          >
          <div class="tint quality rounded"></div>
          <b-img-lazy
            :src="findThumb(i)"
            fluid-grow
            rounded
          ></b-img-lazy>
          <span>{{ i }}</span>
        </label>
      </div>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'Maps',
  data() {
    return {
    }
  },
  props: {
    items: Array,
    input: Object // user input
  },
  methods: {
    findThumb: function(item_name) {
      return `${process.env.BASE_URL}img/thumbs/maps/${item_name}.jpg`;
    }
  }
}
</script>

<style scoped>
#tabs .overflow-y {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 19.7em;
}

#tabs .overflow-y .btn {
  padding: 0;
  border-width: 0;
  border-width: 5px;
  border-color: transparent;
  text-shadow: 0px 0px 4px black, 0px 0px 4px black, 0px 0px 4px black, 0px 0px 4px black;
}

#tabs .overflow-y .btn:hover {
  border-width: 5px;
}

#tabs .overflow-y .btn span {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: white;
  margin: 0.25em;
  line-height: 1.25em;
}

#tabs .overflow-y .btn img {
  background-color: black;
}

#tabs .btn-group .active {
  border-width: 5px;
}

/* Not used to indicate item quality as maps don't have qualities, but useful to add a tint to the map thumbs */
.quality {
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
}

.tint {
  background: linear-gradient(to bottom,transparent 0,rgba(0,0,0,.2) 80%);
}

.btn span {
  z-index: 2;
}

@media (min-width: 768px) {
  #tabs .overflow-y {
    height: 56.38em;
  }
}

</style>